import React from "react";
import { Stack } from "@mui/material";
import "../../styles/generate-captions.scss";
import "../../styles/global.scss";

const TogglesRow = (props) => {
  return (
    <div className="toggles-flex-container">
      <Stack direction="row" alignItems="baseline" className="toggle-row">
        <div className="caption-icon-spacing">
          <i
            onClick={props.toggleHashtags}
            aria-hidden="true"
            className={
                props.useHashtags
                ? "fa fa-lg icon-button fa-toggle-on hashtags-chosen clickable"
                : "fa fa-lg icon-button fa-toggle-off clickable"
            }
          ></i>
        </div>
        <h5>Include Hashtags</h5>
      </Stack>
      <Stack direction="row" alignItems="baseline" className="toggle-row">
        <div className="caption-icon-spacing">
          <i
            onClick={props.toggleEmojis}
            aria-hidden="true"
            className={
                props.useEmojis
                ? "fa fa-lg icon-button fa-toggle-on hashtags-chosen clickable"
                : "fa fa-lg icon-button fa-toggle-off clickable"
            }
          ></i>
        </div>
        <h5>Include Emojis</h5>
      </Stack>
    </div>
  );
};

export default TogglesRow;
